export let EventType;

(function (EventType) {
  EventType["PageView"] = "pageView";
  EventType["Interaction"] = "interaction";
})(EventType || (EventType = {}));

export let ScreenType;

(function (ScreenType) {
  ScreenType["Directory"] = "directory";
  ScreenType["Edit"] = "edit";
  ScreenType["Member"] = "member";
})(ScreenType || (ScreenType = {}));